import React from 'react'
import { Col, Row } from 'reactstrap'

const HomeTestServices = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem2 right-padding5rem2 py-5 '>
            <div className=''>
                <center>
                    <text className='fs-ss-32 fw-700 text-montserrat text-ss-primary' style={{ textTransform:'uppercase', letterSpacing:''}}>
                        Test Services
                    </text>
                    <hr className='hr-style' style={{ width:'60px', marginTop:'0px', marginBottom:'4px'}}/>
                </center>
            </div>

            <div className='pt-3'>
                <Row>
                    <Col md='6' lg='6' xl='3' className='mb-md-0 mb-3 p-0'>
                        <div className='py2 card card-stretch border-0' style={{ backgroundColor:'#f2f2f2', boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', padding:'46px 12px 46px 12px', borderRadius:'50px', margin:'14px'}}>
                        <center>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/08/Toxicology-Test-icon.png' alt='Test Services' height='auto' width='18%' />
                            </div>
                            <div className='py-lg-4 py-md-4 py-2'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-secondary lh-1'>
                                Toxicology (Drug) <br/> Testing
                                </text>
                            </div>

                            <div className='px-4 pb-lg3'>
                                <text className='fs-ss-14-3 text-montserrat fw-600 text-ss-black'>
                                    Toxicology testing by ULC detects drugs in biological samples (urine, blood, hair) to identify recent drug use, aiding compliance checks and safety measures.
                                </text>
                            </div>
                        </center>
                        </div>
                    </Col>

                    <Col md='6' lg='6' xl='3' className='mb-3 p-0' >
                    <div className='card card-stretch border-0' style={{ backgroundColor:'#f2f2f2', boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', padding:'46px', borderRadius:'50px', margin:'14px'}}>
                    <center>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2023/08/Blood-Test-icon.png' alt='Test Services' height='auto' width='19%' />
                            </div>
                            <div className='py-4'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-secondary lh-1'>
                                    Blood (STI/STD) <br/> Testing
                                </text>
                            </div>

                            <div className='px-'>
                                <text className='fs-ss-14-3 text-montserrat fw-600 text-ss-black'>
                                    Blood tests diagnose STIs/STDs by detecting markers in blood samples, enabling early detection, treatment, and prevention of infections.
                                </text>
                            </div>
                        </center>
                        </div>
                    </Col>

                    <Col md='6' lg='6' xl='3' className='mb-3 p-0'>
                    <div className='card card-stretch border-0'  style={{ backgroundColor:'#f2f2f2', boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', padding:'46px 13px', borderRadius:'50px', margin:'14px'}}>
                    <center>
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2022/12/Repiratory-Pathogen-Panel-test-icon.png' alt='Test Services' height='auto' width='25%' />
                            </div>
                            <div className='py-4'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-secondary lh-1'>
                                    Respiratory Pathogen <br/> Panel Testing
                                </text>
                            </div>

                            <div className='px-3 pt-1'>
                                <text className='fs-ss-14-3 text-montserrat fw-600 text-ss-black'>
                                    Get 19 distinct virus tests like RSV (primarily in children) and Influenza (flu) through swabs, guiding timely treatment and containment efforts.                                
                                </text>
                            </div>
                        </center>
                        </div>
                    </Col>

                    <Col md='6' lg='6' xl='3' className='mb-3 pb-md-0 pb-lg-2 p-0' >
                    <div className='card card-stretch border-0'  style={{ backgroundColor:'#f2f2f2', boxShadow:'-6px 6px 12px 1px rgba(155,154,154,.5)', padding:'52px 25px', borderRadius:'50px', margin:'14px'}}>
                    <center >
                            <div className=''>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2022/04/RT-PCR-Test-icon.png' alt='Test Services' height='auto' width='24%' />
                            </div>
                            <div className='pt3 pb2 py-4'>
                                <text className='fs-ss-18 text-montserrat fw-700 text-ss-secondary lh-1'>
                                Covid-19 Testing <br/> Solutions
                                </text>
                            </div>

                            <div className='px-3 pb-xl3 pt1 pt-lg-2 pb-md-3 pb-lg-4 pb-xl-0'>
                                <text className='fs-ss-14-3 text-montserrat fw-600 text-ss-black'>
                                    We offer accurate and efficient RT-PCR and Rapid Antigen testing solutions for symptomatic and asymptomatic cases.
                                </text>
                            </div>
                        </center>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default HomeTestServices